import React from 'react';
const BlackOverlay = ({ position = 'fixed', top = 0, bottom = 0, left = 0, right = 0 }) => {
    return (
        <div style={{ position, top, bottom, left, right, backgroundColor: 'rgba(0, 0, 0, 0.80)', zIndex: 0 }} />
    );
}

export default BlackOverlay;
//